import Vue from 'vue'

const vm = new Vue()

// 获取对应报修类型的具体报修类型信息
export function codeValueList (params) {
  return vm.$http.get('c/api/codeValueList/' + params.code)
}

// 提交报修
export function addrepairs (params) {
  return vm.$http.post('i/api/repairs/addrepairs', params)
}

// 获取我的报修列表
export function query (params) {
  return vm.$http.post('i/api/repairs/query', params)
}

// 提交评价
export function evaluate (params) {
  return vm.$http.post('i/api/repairs/evaluate', params)
}
